module.exports = __webpack_public_path__ + "img/1348470106.0053b403.jpg";